// There is a confirmation dialog for <Unknown Tag>s, so
// a user can sit there forever.
const MARKALL_TIMEOUT = 31536000000; // 365 days (MAX_SAFE_INTEGER doesn't work for some reason)
export default MARKALL_TIMEOUT;
